import { SHORTEN_URL_FAILURE, SHORTEN_URL_REQUEST, SHORTEN_URL_SUCCESS, UrlShortenerActionTypes, UrlShortenerData } from "../action/urlShortener-action";

interface UrlShortenerState {
  loading: boolean;
  data: UrlShortenerData | null;
  error: string | null;
}

const initialState: UrlShortenerState = {
  loading: false,
  data: null,
  error: null,
};

export const urlShortenerReducer = (
  state = initialState,
  action: UrlShortenerActionTypes
): UrlShortenerState => {
  switch (action.type) {
    case SHORTEN_URL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case SHORTEN_URL_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case SHORTEN_URL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        data: action.payload.longUrl
          ? { shorturl: "", longUrl: action.payload.longUrl }
          : state.data,
      };

    default:
      return state;
  }
};
